/** CoStar.Api.ConsumerUserData.Schools.SchoolLevel */
export var SchoolLevel;
(function (SchoolLevel) {
    SchoolLevel[SchoolLevel["Unknown"] = 0] = "Unknown";
    SchoolLevel[SchoolLevel["Elementary"] = 1] = "Elementary";
    SchoolLevel[SchoolLevel["Middle"] = 2] = "Middle";
    SchoolLevel[SchoolLevel["High"] = 3] = "High";
})(SchoolLevel || (SchoolLevel = {}));
/** CoStar.Api.ConsumerUserData.Schools.SchoolType */
export var SchoolType;
(function (SchoolType) {
    SchoolType[SchoolType["Unknown"] = 0] = "Unknown";
    SchoolType[SchoolType["Public"] = 1] = "Public";
    SchoolType[SchoolType["Private"] = 2] = "Private";
})(SchoolType || (SchoolType = {}));
